import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { getDialogContextValue } from '../../../../redux/selectors';

import ReduxDialog from '../../../Common/ReduxDialog/index';

import styles from './styles';

import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { fetchItemTypesRoutine, fetchTaskProfileRoutine, saveTaskProfileFormHandler } from '../../../../redux/routines';
import { renderTaskProfileItemTypes, renderTextField } from '../../../../utils/reduxforms';
import { TASK_PROFILE_DIALOG } from '../../../../redux/constants/dialogs';
import { toJS } from '../../../../utils/helper';

class TaskProfileDialog extends Component {

  state = {};

  componentWillMount() {
    this.props.fetchItemTypes();
  }

  render() {
    const { handleSubmit, initialValues, showDialog, itemTypes, submit } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(TASK_PROFILE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        onClick={() => submit()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        title={initialValues.get('name') || 'Create Task Profile...'}
        subTitle={'Task profiles allow you to define a common configuration of items for a task'}
        actions={actions}
        name={TASK_PROFILE_DIALOG}
        bodyStyle={styles.body}
        maxWidth="sm"
        fullWidth
      >
        <Form name="TaskProfile" onSubmit={handleSubmit(saveTaskProfileFormHandler)} style={styles.form}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                fullWidth/>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="description"
                component={renderTextField}
                label="Description"
                fullWidth
                multiline
                rows={2}/>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="itemTypes"
                component={renderTaskProfileItemTypes}
                label="Name"
                fullWidth
                showDialog={showDialog}
                itemTypes={itemTypes}
              />
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

TaskProfileDialog.propTypes = {
  itemTypes: PropTypes.array.isRequired,

  initialValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: TASK_PROFILE_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog(TASK_PROFILE_DIALOG);
  },
  onSubmitFail: (err) => {
    console.log('onSubmitFail', err);
  },
})(TaskProfileDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTaskProfile: fetchTaskProfileRoutine.trigger,
    fetchItemTypes: fetchItemTypesRoutine.trigger,

    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    initialValues: getDialogContextValue(state)(TASK_PROFILE_DIALOG, 'taskProfile'),
    itemTypes: toJS(state.getIn(['itemtypes', 'itemTypes', 'data'])),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfileDialog/index.js